export const OPERATORS_LIST_URL: string = 'account/{accountId}/event/{eventId}/operators';
export const ALL_OPERATORS_LIST_URL: string = 'operator/list';